import React, { useEffect } from 'react';
import api from '../../services/api';

// Componente que carrega o manifest dinâmico baseado no branchId
const KioskManifestLoader = ({ branchId }) => {
  useEffect(() => {
    if (!branchId) return;

    const loadManifest = async () => {
      try {
        // Buscar manifest do backend - usar URL direta da API
        const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api-barberpro.empresteja.com/api';
        const manifestUrl = `${API_BASE_URL}/kiosk/manifest/${branchId}`;
        
        // Criar ou atualizar link para manifest dinâmico
        let manifestLink = document.querySelector('link[rel="manifest"]');
        if (!manifestLink) {
          manifestLink = document.createElement('link');
          manifestLink.rel = 'manifest';
          document.head.appendChild(manifestLink);
        }
        
        // Usar URL direta do backend (mais confiável que blob)
        manifestLink.href = manifestUrl;

        // Buscar dados do manifest para atualizar meta tags
        try {
          const response = await fetch(manifestUrl);
          const manifest = await response.json();
          
          // Atualizar meta tags para iOS
          let appleMeta = document.querySelector('meta[name="apple-mobile-web-app-title"]');
          if (!appleMeta) {
            appleMeta = document.createElement('meta');
            appleMeta.name = 'apple-mobile-web-app-title';
            document.head.appendChild(appleMeta);
          }
          appleMeta.content = manifest.short_name || manifest.name;

          // Atualizar título da página
          if (manifest) {
            if (manifest.name) {
              document.title = manifest.name;
            } else {
              document.title = manifest.short_name || 'Barbx';
            }
          }

          console.log('✅ Manifest PWA carregado para barbearia:', branchId, manifest.name);
        } catch (fetchError) {
          console.error('Erro ao buscar dados do manifest:', fetchError);
        }
      } catch (error) {
        console.error('Erro ao carregar manifest:', error);
      }
    };

    loadManifest();
  }, [branchId]);

  return null; // Componente não renderiza nada
};

export default KioskManifestLoader;

